import {
	type ImportDefinitionContract,
	type ImportDesignerDryRun,
	type ImportDesignerInspection,
	type ImportDesignerPreview,
	type ImportDesignerSample,
	TenantConfigPlane,
} from '@today/types'
import { apiClient } from './api.client'

/** The designer route tree of a console plane (TO-400 Contract; TO-632 nested under import-definitions). */
const designerOf = (tenantId: string, plane: TenantConfigPlane) =>
	plane === TenantConfigPlane.PLATFORM
		? `/admin/tenants/${encodeURIComponent(tenantId)}/import-definitions/designer`
		: '/import-definitions/designer'

/** The import-definition designer (TO-400): read-only calls on the real engine; nothing is stored. */
export const importDesignerService = {
	async inspect(tenantId: string, plane: TenantConfigPlane, sample: ImportDesignerSample) {
		const { data } = await apiClient.post<ImportDesignerInspection>(`${designerOf(tenantId, plane)}/inspect`, {
			sample,
		})
		return data
	},

	async preview(
		tenantId: string,
		plane: TenantConfigPlane,
		contract: ImportDefinitionContract,
		sample: ImportDesignerSample,
	) {
		const { data } = await apiClient.post<ImportDesignerPreview>(`${designerOf(tenantId, plane)}/preview`, {
			contract,
			sample,
		})
		return data
	},

	async dryRun(
		tenantId: string,
		plane: TenantConfigPlane,
		contract: ImportDefinitionContract,
		sample: ImportDesignerSample,
	) {
		const { data } = await apiClient.post<ImportDesignerDryRun>(`${designerOf(tenantId, plane)}/dry-run`, {
			contract,
			sample,
		})
		return data
	},
}
